export default class WCArchivePayuInstallments {
    constructor() {
        this.productsGrid = document.querySelector('.jsWcArchiveGrid');

        if (this.productsGrid) {
            this.events();
        }
    }

    events() {
        this.showPayuInstallments();

        this.productsGrid.addEventListener(
            'addedNewProductsToGrid',
            this.showPayuInstallments.bind(this),
        );
    }

    showPayuInstallments() {
        if (!window.OpenPayU) return;

        const allVisibleProducts = [
            ...this.productsGrid.querySelectorAll('.jsWcArchiveProductExtra'),
        ];

        if (!allVisibleProducts.length) return;

        allVisibleProducts.forEach((prod) => {
            const creditAmount = parseFloat(prod.dataset.price);
            const posId = prod.dataset.payuPosid;
            const key = prod.dataset.payuWidgetkey;
            const prodId = prod.dataset.productid;

            if (!creditAmount || !posId || !key || !prodId) return;

            const options = {
                creditAmount,
                posId,
                key,
                showLongDescription: true,
            };

            // eslint-disable-next-line no-undef
            OpenPayU.Installments.miniInstallment(
                `#installment-mini-${prodId}`,
                options,
            );
        });
    }
}
